import Button from '@components/Button';
import Column from '@components/Column';
import Row from '@components/Row';
import useAppCustom from '@hooks/useAppCustom';
import { OrderLogResponse } from '@models/order/orderLog';
import { useFlow } from '@router/stackflow';

import useReOrder from './hooks/useReOrder';
import styles from './styles.module.scss';

interface Props {
    orderLog: OrderLogResponse;
}

function OrderFooter({ orderLog }:Props) {
  const { useOrderCancelButton } = useAppCustom().orderLog;
  const {
    status, orderNo,
  } = orderLog;
  const { reOrder, reOrderEnabled } = useReOrder(orderLog);
  const cancelable = useOrderCancelButton && status === 'NEW';
  const { push } = useFlow();
  return (
        <Column fullWidth spacing={20}>
            {/*
            <div className={styles.info}>
                <Text size='lg' fontWeight='bold' color={colors.gray6}>
                    결제수단
                </Text>
                <Text size='lg' className={status === 'CANCELLED' ? styles.canceled : ''}>
                    {PaymentMethodKr[paymentMethod]}
                </Text>
                <Text size='lg' fontWeight='bold' color={colors.gray6}>
                    상품금액
                </Text>
                <Text size='lg' className={status === 'CANCELLED' ? styles.canceled : ''}>
                    {totalAmount.toLocaleString()}원
                </Text>
                <Text size='lg' fontWeight='bold' color={colors.gray6}>
                    할인금액
                </Text>
                <Text size='lg' className={status === 'CANCELLED' ? styles.canceled : ''}>
                    -{totalDiscount.toLocaleString()}원
                </Text>
            </div>

            <Row fullWidth justify='space-between' className={styles.total}>
                <Text size='xl' fontWeight='bold' >
                    결제금액
                </Text>
                <Text size='3xl' color={colors.red} fontWeight='bold'
                      className={status === 'CANCELLED' ? styles.canceled : ''}>
                    {paymentAmount.toLocaleString()}원
                </Text>
            </Row>
            */}
            <Row spacing={12} fullWidth>
                {cancelable && (
                    <Button variant='tertiary'
                            className={styles.button}
                            onClick={() => push('CancelOrderModal', { orderNo })} >
                        주문취소
                    </Button>
                )}
                <Button className={styles.button}
                        disabled={!reOrderEnabled}
                        onClick={reOrder} >
                    재주문
                </Button>
            </Row>
        </Column>
  );
}

export default OrderFooter;
